import * as apiClient from "./controllers";
export { default as ForumSeminarType } from "./controllers/forumSeminarType";

export default apiClient;
